export default "__VITE_ASSET__CkRDu7qk__"